export default __webpack_public_path__ + "static/media/PlayStore.ee4e5a89.svg";